import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {TranslatePipe} from '@aztrix/translate';
import {IconsModule} from '@aztrix/icons';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';

import {LanguageSelectSearchComponent} from './language-select-search.component';
import {HelperPipesModule} from '@aztrix/helpers';

@NgModule({
  declarations: [LanguageSelectSearchComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    IconsModule,
    HelperPipesModule,
    TranslatePipe,
  ],
  exports: [LanguageSelectSearchComponent],
})
export class LanguageSelectSearchModule {}
